(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  
  function verticalVideoAdjust(){
      document.querySelectorAll('.yt-video-wrap.vertical').forEach((el)=>{
          let width = el.offsetWidth;
          let height = width*1.778+'px';
          el.style.paddingBottom = height;
      })
    document.querySelectorAll('.yt-video-wrap.horizontal').forEach((el)=>{
          let width = el.offsetWidth;
          let height = width*0.5625+'px';
          el.style.paddingBottom = height;
      })
  }
  addEventListener('DOMContentLoaded', (event) => {
    verticalVideoAdjust();
  })
  window.addEventListener('resize', ()=>{
      verticalVideoAdjust();
  })

  } catch(e) { console.error(e); }
})();
})();
